import { memo } from 'react';

import AllRunsIconSVG from '@/assets/all-runs-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAllRunsIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={AllRunsIconSVG} {...props} />;

export const AllRunsIcon = memo(IAllRunsIcon) as typeof IAllRunsIcon;
